import React, { useState } from 'react';
import { ConfigDialog } from '../../dummies/ConfigDialog/ConfigDialog';
import templates from './templates';
import './FinancialGaugeWidget.css';

export const FINANCIAL_GAUGE_WIDTH = 400;
export const FINANCIAL_GAUGE_HEIGHT = 400;

const DEFAULT_DATA = {
    incomeData: [
        { id: 'donations', label: 'תרומות', value: 6000, color: '#1e3a5f' },
        { id: 'events', label: 'אירועים', value: 3000, color: '#2d5a8f' }
    ],
    expensesData: [
        { id: 'salaries', label: 'משכורות', value: 400, color: '#d4af37' },
        { id: 'maintenance', label: 'תחזוקה', value: 2000, color: '#e6c45e' },
        { id: 'utilities', label: 'חשמל ומים', value: 1000, color: '#f0d98d' }
    ]
};

export const FinancialGaugeWidget = ({
    data = DEFAULT_DATA,
    onSave,
    template = 'Gauge',
    title = 'תמונת מצב כספית',
    showTitle = false
}) => {
    const [isConfigOpen, setIsConfigOpen] = useState(false);
    const [formData, setFormData] = useState(data);

    const handleSave = () => {
        if (onSave) onSave(formData);
        setIsConfigOpen(false);
    };

    const addItem = (type) => {
        const newItem = {
            id: `${type}_${Date.now()}`,
            label: '',
            value: 0,
            color: type === 'expenses' ? '#1e3a5f' : '#d4af37'
        };
        setFormData(prev => ({
            ...prev,
            [`${type}Data`]: [...prev[`${type}Data`], newItem]
        }));
    };

    const updateItem = (type, index, field, value) => {
        setFormData(prev => ({
            ...prev,
            [`${type}Data`]: prev[`${type}Data`].map((item, i) =>
                i === index ? { ...item, [field]: value } : item
            )
        }));
    };

    const removeItem = (type, index) => {
        setFormData(prev => ({
            ...prev,
            [`${type}Data`]: prev[`${type}Data`].filter((_, i) => i !== index)
        }));
    };

    const Template = templates[template];

    if (!Template) {
        return <div>Template not found: {template}</div>;
    }

    return (
        <>
            <Template
                incomeData={data.incomeData}
                expensesData={data.expensesData}
                title={title}
                showTitle={showTitle}
            />

            <ConfigDialog
                open={isConfigOpen}
                onClose={() => setIsConfigOpen(false)}
                onConfirm={handleSave}
                title="הגדרות תמונת מצב כספית"
            >
                <div className="financial-gauge-config">
                    <div className="financial-gauge-config__section">
                        <h3 style={{ color: '#1e3a5f', marginBottom: '1em' }}>הכנסות</h3>
                        {formData.incomeData.map((item, index) => (
                            <div key={item.id} className="financial-gauge-config__item">
                                <input
                                    type="text"
                                    placeholder="שם מקור הכנסה"
                                    value={item.label}
                                    onChange={(e) => updateItem('income', index, 'label', e.target.value)}
                                    className="financial-gauge-config__input"
                                />
                                <input
                                    type="number"
                                    placeholder="סכום"
                                    value={item.value}
                                    onChange={(e) => updateItem('income', index, 'value', parseInt(e.target.value) || 0)}
                                    className="financial-gauge-config__input"
                                />
                                <input
                                    type="color"
                                    value={item.color}
                                    onChange={(e) => updateItem('income', index, 'color', e.target.value)}
                                    className="financial-gauge-config__color"
                                />
                                <button
                                    onClick={() => removeItem('income', index)}
                                    className="financial-gauge-config__remove"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                        <button
                            onClick={() => addItem('income')}
                            className="financial-gauge-config__add"
                        >
                            + הוסף הכנסה
                        </button>
                    </div>

                    <div className="financial-gauge-config__section">
                        <h3 style={{ color: '#d4af37', marginBottom: '1em' }}>הוצאות</h3>
                        {formData.expensesData.map((item, index) => (
                            <div key={item.id} className="financial-gauge-config__item">
                                <input
                                    type="text"
                                    placeholder="שם הוצאה"
                                    value={item.label}
                                    onChange={(e) => updateItem('expenses', index, 'label', e.target.value)}
                                    className="financial-gauge-config__input"
                                />
                                <input
                                    type="number"
                                    placeholder="סכום"
                                    value={item.value}
                                    onChange={(e) => updateItem('expenses', index, 'value', parseInt(e.target.value) || 0)}
                                    className="financial-gauge-config__input"
                                />
                                <input
                                    type="color"
                                    value={item.color}
                                    onChange={(e) => updateItem('expenses', index, 'color', e.target.value)}
                                    className="financial-gauge-config__color"
                                />
                                <button
                                    onClick={() => removeItem('expenses', index)}
                                    className="financial-gauge-config__remove"
                                >
                                    ✕
                                </button>
                            </div>
                        ))}
                        <button
                            onClick={() => addItem('expenses')}
                            className="financial-gauge-config__add"
                        >
                            + הוסף הוצאה
                        </button>
                    </div>
                </div>
            </ConfigDialog>
        </>
    );
};
